export default function exploreBlocks() {
  const widgetName = 'exploreBlocks';
  const widgetOpts = exploreBlocksOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: [''],
    showDescription: true,
    moreButton: false,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 4,
    itemsPerPanel: 1,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomExploreBlocks(data.items);
      } else {
        $(`#${widgetName}`).remove();
      }
    },
  });

  function createCustomExploreBlocks(widgetData) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, Description } = widgetData[x];

      const $cardItem = $(this);

      $cardItem.replaceWith(`
          <div class="card-content">
            <h3 class="block-title">${Title}</h3>    
            ${Description ? `<p class="block-description">${Description}</p>` : ''}
           </div>`);
    });
  }
}
